import { TakenSubdomainTypeEnum } from '@zaoblako/shared/modules/saas/enums/taken-subdomain-type.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';

import * as yup from 'yup';

/** Taken subdomain response body - DTO signature */
export interface TakenSubdomainInterface {
  /** Subdomain value */
  subdomain: string;
  /** Subdomain type */
  type: TakenSubdomainTypeEnum;
  /** Subdomain take date and time */
  created: Date;
}

/** Taken subdomain response body - DTO schema */
export const TakenSubdomainDto = SerdeDtoClass.create<TakenSubdomainInterface>(SaasDtoKeysEnum.TAKEN_SUBDOMAIN_DTO, {
  subdomain: {
    label: 'Поддомен',
    serializer: yup.string(),
  },
  type: {
    label: 'Тип',
    serializer: yup
      .string()
      .oneOf(Object.values(TakenSubdomainTypeEnum)),
  },
  created: {
    label: 'Дата создания',
    serializer: yup.date(),
  },
});
